import { render, staticRenderFns } from "./babyloan-ko.pug?vue&type=template&id=36833cae&lang=pug&external"
import script from "./babyloan-ko.js?vue&type=script&lang=js&external"
export * from "./babyloan-ko.js?vue&type=script&lang=js&external"
import style0 from "./babyloan-ko.vue?vue&type=style&index=0&id=36833cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports